import React from 'react'
import { withIcon } from '../../withIcon'

function StackIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}>
      <path d="M6.45166 6.57692H20.3333C20.6402 6.57692 20.8889 6.818 20.8889 7.11539V15.1853C21.5136 15.1202 22 14.6075 22 13.9847V6.70758C22 6.04065 21.4422 5.5 20.7541 5.5H7.69037C7.04781 5.5 6.51887 5.97145 6.45166 6.57692Z" fill={color}/>
      <path d="M19.7778 8.86143C19.7778 8.1945 19.22 7.65385 18.5319 7.65385H5.46814C4.82558 7.65385 4.29664 8.1253 4.22943 8.73077H18.1111C18.4179 8.73077 18.6667 8.97185 18.6667 9.26924V17.3392C19.2914 17.274 19.7778 16.7614 19.7778 16.1386L19.7778 8.86143Z" fill={color}/>
      <path fillRule="evenodd" clipRule="evenodd" d="M16.3096 11.0153H3.24591L3.24591 18.2924L16.3096 18.2924L16.3096 11.0153ZM3.24591 9.80768C2.55781 9.80768 2 10.3483 2 11.0153V18.2924C2 18.9593 2.55781 19.5 3.24591 19.5H16.3096C16.9977 19.5 17.5555 18.9593 17.5555 18.2924V11.0153C17.5555 10.3483 16.9977 9.80768 16.3096 9.80768H3.24591Z" fill={color}/>
    </svg>
  )
}

export default withIcon(StackIcon)
